export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11165.41e4500c.jpg";